import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const FinancialMetrics = ({ stats }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
        }).format(amount);
    };

    return (
        <Row className="g-4 mt-2">
            <Col md={12}>
                <Card className="shadow-sm border-0 text-white overflow-hidden" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
                    <Card.Body className="p-4">
                        <Row className="align-items-center">
                            <Col md={8}>
                                <div className="text-light opacity-75 small text-uppercase fw-bold letter-spacing-1 mb-1">Net Revenue Recovered</div>
                                <h1 className="display-5 mb-0 fw-bold">{formatCurrency(stats.payments.totalAmount)}</h1>
                            </Col>
                            <Col md={4} className="text-md-end mt-3 mt-md-0">
                                <div className="bg-white bg-opacity-25 rounded p-3 text-center">
                                    <div className="text-light small mb-1">Collection Rate</div>
                                    <div className="fw-bold h2 mb-0">
                                        {stats.payments.successfulPayments + stats.payments.failedPayments > 0
                                            ? ((stats.payments.successfulPayments / (stats.payments.successfulPayments + stats.payments.failedPayments)) * 100).toFixed(1)
                                            : 0}%
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default FinancialMetrics;
